module.exports = __webpack_public_path__ + "media/images/browsers/safari-3feaa4f5becc973b96298ce62533ebb5.svg";